<div class="talonpicker" [class.closing]="isClosing" #pickerContainer>
    <div class="top__row">
        <mat-select
            [(value)]="selectedDep"
            [placeholder]="
                filialFromParams && filialFromParams.length > 0
                    ? filialFromParams[0].dep_name || 'Выберите адрес'
                        : depList.length === 1 ? depList[0].text
                    : 'Выберите адрес'
            "
            class="dep__select talonpicker__dep-select"
            [disabled]="filialFromParams[0]"
        >
            <mat-option
                *ngFor="let dep of depList"
                [value]="dep.keyid"
                (click)="selectDep(dep)"
                class="dep-select__option"
            >
                {{ dep.text }}
            </mat-option>
        </mat-select>
        <button class="btn btn-dialog-close" (click)="closeCalendar()">
            <img src="./assets/img/svg/cross.svg" alt="Закрыть" />
        </button>
    </div>

    <div *ngIf="loading" class="loading">
        <loader type="page"> </loader>
    </div>

    <mat-calendar
        *ngIf="talonListAll.length !== 0 && (depList.length === 1 || selectedDep !== null)"
        class="calendar talonpicker__calendar"
        #calendar
        [dateFilter]="dateFilter"
        [(selected)]="selectedDay"
        (selectedChange)="selectDay($event)"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [headerComponent]="header"
    ></mat-calendar>

    <div 
        class="record talonpicker__record"
        *ngIf="(depList.length === 1 || selectedDep !== null)"
    >
        <div
            class="record__title"
            *ngIf="
                !(
                    talonListFiltered.length !== 0 &&
                    talonListFiltered[0].rnumbid === null &&
                    talonListFiltered[0].interval_id === null
                )
            "
        >
            Свободно на <br />
            <span class="record__title-date"
                >{{ selectedDay?.locale("ru")?.format("DD MMMM YYYY") }}
            </span>
        </div>
        <div
            class="record__title"
            *ngIf="
                talonListFiltered.length !== 0 &&
                talonListFiltered[0].rnumbid === null &&
                talonListFiltered[0].interval_id === null
            "
        >
            Вы записываетесь на <br />
            <span class="record__title-date">{{
                selectedDay?.locale("ru")?.format("DD MMMM YYYY")
            }}</span>
        </div>

        <div class="talons__empty" *ngIf="talonListFiltered.length === 0">
            Нет доступных номерков
        </div>

        <div
            class="talonlist record__talonlist"
            *ngIf="
                (talonListFiltered.length !== 0 &&
                    talonListFiltered[0].interval_id !== null) ||
                talonListFiltered[0]?.rnumbid !== null
            "
        >
            <!-- (click)="clickTalon($event, talon)" -->
            <div
                class="talon talonlist__item"
                [class.active]="talon === pickedTalon"
                *ngFor="let talon of talonListFiltered"
                (click)="openTalonModal($event, talon)"
                [ngClass]="{
                    disabled: !talonDisable(talon)
                }"
            >
                {{ talon.dtBegin | date : "HH:mm" }}
                <!-- Подсказка только для отключённых талонов -->
                <div *ngIf="!talonDisable(talon)" class="tooltip">
                    Номерок для другой услуги
                </div>
            </div>
        </div>
    </div>

    <ng-container
        *ngIf="
            talonListFiltered.length !== 0 &&
            talonListFiltered[0].rnumbid === null &&
            talonListFiltered[0].interval_id === null
        "
    >
        <button
            class="btn btn-dialog-accept"
            (click)="openTalonModal($event, talonListFiltered[0])"
        >
            Продолжить
        </button>
    </ng-container>

    <ng-container
        *ngIf="
            !(
                talonListFiltered.length !== 0 &&
                talonListFiltered[0].rnumbid === null &&
                talonListFiltered[0].interval_id === null
            )
        "
    >
    </ng-container>
</div>
